const WIF = ({ ...props }) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 600 600"
    {...props}
  >
    <path
      className="st0"
      d="M300,0C134.3,0,0,134.3,0,300s134.3,300,300,300s300-134.3,300-300S465.7,0,300,0z M449,347
 c-13-29-61-93-131-86c-73,8-156,49-180,109c-37-29-5-79,17-102c-5-22,9-70,17-90c3-17,17-29,24-32c-1-12,20-18,30-20l1-2
 c3-9,6-20,32-28c22-8,42,12,50,23c2-6,10-15,18-8c72,11,96,90,100,127c14,10,43,36,50,60c7,29-1,35-11,43l-2,2
 C459,349,453,349,449,347z M435,378c-15.7,65.8-68.5,116.3-135,129c-42,0-109-66-128-97c-39-3-30-23-21-32l-5-2c18-42,69-92,169-104
 c55-7,97,32,122,72C438,357,437,371,435,378z M216,328c6,15,24,39,50,11C264,331,250,317,216,328z M256,470c-4-6,20-9,32-10l16-4
 c3-13-3-14-6-13c-24,2-22-26-16-35c7-8,22-5,27-4c5,2,13,0,16-1c15-1,14,17,11,26c-1,12-18,16-26,16c-1,9,1,13,3,13l34,8
 c13,5,6,6,0,7c-17-11-29-7-37-5l-6,2c-14-5-29-4-35-2C266,471,259,475,256,470z M345,344c1-12,13-32,48-14C388,342,371,361,345,344z
 "
    />
  </svg>
);
export default WIF;
